var transbank = {
	data () {
		return {
			connecting: false,
			connectData: {
				token: '',
				url: '',
				buyOrder: ''
			},
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		connectTransbank(amount, orderTokens) {
			this.connecting = true
			let url = this.getApiBackend + 'transbank/connect'
			let data = {
					amount: amount,
					orderTokens: orderTokens
				}
			this.axiosLocal('POST', url, 'connectTransbankResult', data)
		},
		connectTransbankResult(response) {
			if(response.data.success == true) {
				this.connectData.token = response.data.data.token
				this.connectData.url = response.data.data.url
				this.connectData.buyOrder = response.data.data.buyOrder
				this.connecting = false
				this.connectTransbankResultLocal(response)
			} else {
				this.connectTransbankResultError(response)
			}
		},
		connectTransbankResultLocal(response) {
			console.log('connectTransbankResultLocal no desarrollado', response)
		},
		connectTransbankResultError(error) {
			this.connecting = false
			this.$awn.alert('No se pudo obtener el Token de Transbank')
			console.log(error)
		},
		commit(token, action) {
			this.connecting = true
			let url = this.getApiBackend + 'transbank/commit'
			let data = {
					token: token,
					action: action
				}
			console.log(url, data)
			this.axiosLocal('POST', url, 'commitTransbankResult', data)
		},
		commitTransbankResult(response) {
			if(response.data.success == true) {
				this.commitTransbankResultLocal(response)
			} else {
				this.commitTransbankResultError(response)
			}
		},
		commitTransbankResultError(error) {
			this.connecting = false
			this.$awn.alert('No se pudo obtener el Token de Transbank')
			console.log(error)
			this.commitTransbankResultErrorLocal(error)
		},
		commitTransbankResultErrorLocal(error) {
			console.log('commitTransbankResultErrorLocal no desarrollado', error)
		}
	},
}

export default transbank;